import { render, staticRenderFns } from "./ContentConfig.vue?vue&type=template&id=279685a4&scoped=true"
import script from "./ContentConfig.vue?vue&type=script&lang=js"
export * from "./ContentConfig.vue?vue&type=script&lang=js"
import style0 from "./ContentConfig.vue?vue&type=style&index=0&id=279685a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279685a4",
  null
  
)

export default component.exports